import * as paymentService from '../services/payment'
import { FinalizePaymentData } from '../types/paymentType'

export const ACTIONS = {
  POST_DAD_PAYMENT_REQUEST: 'POST_DAD_PAYMENT_REQUEST',
  POST_DAD_PAYMENT_SUCCESS: 'POST_DAD_PAYMENT_SUCCESS',
  POST_DAD_PAYMENT_FAILURE: 'POST_DAD_PAYMENT_FAILURE ',
  POST_SUB_PAYMENT_REQUEST: 'POST_SUB_PAYMENT_REQUEST',
  POST_SUB_PAYMENT_SUCCESS: 'POST_SUB_PAYMENT_SUCCESS',
  POST_SUB_PAYMENT_FAILURE: 'POST_SUB_PAYMENT_FAILURE ',
  POST_FINALIZE_DAD_PAYMENT_REQUEST: 'POST_FINALIZE_DAD_PAYMENT_REQUEST',
  POST_FINALIZE_DAD_PAYMENT_SUCCESS: 'POST_FINALIZE_DAD_PAYMENT_SUCCESS',
  POST_FINALIZE_DAD_PAYMENT_FAILURE: 'POST_FINALIZE_DAD_PAYMENT_FAILURE ',
}

export const POST_DAD_PAYMENT_REQUEST = () => ({
  type: ACTIONS.POST_DAD_PAYMENT_REQUEST,
})

export const POST_DAD_PAYMENT_SUCCESS = (paymentResult) => ({
  type: ACTIONS.POST_DAD_PAYMENT_SUCCESS,
  paymentResult,
})

export const POST_DAD_PAYMENT_FAILURE = (err) => ({
  type: ACTIONS.POST_DAD_PAYMENT_FAILURE,
  err,
})

export function postDadPayment(data, token) {
  return (dispatch) => {
    dispatch(POST_DAD_PAYMENT_REQUEST())

    return paymentService.postDadPayment(data, token).then(
      (response) => dispatch(POST_DAD_PAYMENT_SUCCESS(response)),
      (err) => dispatch(POST_DAD_PAYMENT_FAILURE(err))
    )
  }
}

export function postBypassDadPayment(data, token) {
  return (dispatch) => {
    dispatch(POST_DAD_PAYMENT_REQUEST())

    return paymentService.postBypassDadPayment(data, token).then(
      (response) => dispatch(POST_DAD_PAYMENT_SUCCESS(response)),
      (err) => dispatch(POST_DAD_PAYMENT_FAILURE(err))
    )
  }
}

export function postWireTransferDadPayment(data, token) {
  return (dispatch) => {
    dispatch(POST_DAD_PAYMENT_REQUEST())

    return paymentService.postWireTransferDadPayment(data, token).then(
      (response) => dispatch(POST_DAD_PAYMENT_SUCCESS(response)),
      (err) => dispatch(POST_DAD_PAYMENT_FAILURE(err))
    )
  }
}

export const POST_SUB_PAYMENT_REQUEST = () => ({
  type: ACTIONS.POST_SUB_PAYMENT_REQUEST,
})

export const POST_SUB_PAYMENT_SUCCESS = (paymentResult) => ({
  type: ACTIONS.POST_SUB_PAYMENT_SUCCESS,
  paymentResult,
})

export const POST_SUB_PAYMENT_FAILURE = (err) => ({
  type: ACTIONS.POST_SUB_PAYMENT_FAILURE,
  err,
})

export function postSubPayment(data, token) {
  return (dispatch) => {
    dispatch(POST_SUB_PAYMENT_REQUEST())

    return paymentService.postSubPayment(data, token).then(
      (response) => dispatch(POST_SUB_PAYMENT_SUCCESS(response)),
      (err) => dispatch(POST_SUB_PAYMENT_FAILURE(err))
    )
  }
}

export const POST_FINALIZE_DAD_PAYMENT_REQUEST = () => ({
  type: ACTIONS.POST_FINALIZE_DAD_PAYMENT_REQUEST,
})

export const POST_FINALIZE_DAD_PAYMENT_SUCCESS = (result) => ({
  type: ACTIONS.POST_FINALIZE_DAD_PAYMENT_SUCCESS,
  result,
})

export const POST_FINALIZE_DAD_PAYMENT_FAILURE = (err) => ({
  type: ACTIONS.POST_FINALIZE_DAD_PAYMENT_FAILURE,
  err,
})

export function postFinalizeDadPayment(
  data: FinalizePaymentData,
  token: string
) {
  return (dispatch) => {
    dispatch(POST_FINALIZE_DAD_PAYMENT_REQUEST())

    return paymentService.postFinalizeDadPayment(data, token).then(
      (response) => dispatch(POST_FINALIZE_DAD_PAYMENT_SUCCESS(response)),
      (err) => dispatch(POST_FINALIZE_DAD_PAYMENT_FAILURE(err))
    )
  }
}
